import {
  CardsIcon,
  CardSlashIcon,
  ChevronDoubleUpIcon,
  SecurityCardIcon,
} from "icons/outline";
import type { RiskRule } from "../types";
import EntityCard from "../../../components/EntityCard";
import { MouseEventHandler } from "react";

type RuleCardProps = {
  rule: RiskRule;
  deleteActionName: string;
  onClick?: () => void;
  cardMenu?: React.ReactNode;
  onDeleteRule: MouseEventHandler<HTMLButtonElement> | undefined;
};

const riskLevelContent = {
  MEDIUM_RISK: (
    <div className="flex items-center space-x-2">
      <ChevronDoubleUpIcon className="h-4 w-4 rounded-full bg-warning-bold p-0.5 text-foundations-inverse" />
      <span>Medium risk</span>
    </div>
  ),
  HIGH_RISK: (
    <div className="flex items-center space-x-2">
      <ChevronDoubleUpIcon className="h-4 w-4 rounded-full bg-danger-bold p-0.5 text-foundations-inverse" />
      <span>High risk</span>
    </div>
  ),
};

export function RiskRuleCard({
  onClick,
  rule,
  deleteActionName,
  onDeleteRule,
}: RuleCardProps) {
  const { id, name, risk_level, should_block } = rule;

  return (
    <EntityCard
      icon={<SecurityCardIcon className="h-5 w-5" />}
      imageDimensions={72}
      subTitle={"Rule"}
      title={name}
      id={`${id}`}
      primaryAction={
        onClick ? (
          <EntityCard.PrimaryButton onClick={onClick}>
            View rule
          </EntityCard.PrimaryButton>
        ) : (
          ""
        )
      }
      secondaryAction={
        <EntityCard.SecondaryButton
          colorScheme={"danger"}
          onClick={onDeleteRule}
        >
          {deleteActionName}
        </EntityCard.SecondaryButton>
      }
    >
      <div className="flex items-center gap-2 text-sm font-medium text-foundations-subtle md:py-[7px]">
        {riskLevelContent[risk_level]}

        <div className="flex items-center gap-2">
          <span className="-ml-2">, </span>

          {should_block ? (
            <>
              <CardSlashIcon
                width={16}
                height={16}
                className="shrink-0 text-foundations-subtler"
              />

              <span className="whitespace-nowrap">Block</span>
            </>
          ) : (
            <>
              <CardsIcon
                width={16}
                height={16}
                className="shrink-0 text-foundations-subtler"
              />

              <span className="whitespace-nowrap">N/A</span>
            </>
          )}
        </div>
      </div>
    </EntityCard>
  );
}
